import React from "react";
import { toast } from "react-toastify";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  createDgLockerApi,
  previousAddressApi,
  createAddressModifyRequestApi,
} from "designs/v1/pages/ModifyKyc/services";
import { DEMO_API_URL, getApiUrl } from "utils";

const Digilocker = ({
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
  setRequestData,
  setIsDigilocker,
}) => {
  const createModifyRequest = async () => {
    setIsLoading(true);
    try {
      const payload = { request_type: stageScreen };
      const resp = await createAddressModifyRequestApi(payload);
      console.log("resp", resp);
      setIsLoading(false);
      if (resp.data.message?.status_code !== 200) {
        return toast.error(resp.data.message?.message);
      }
      localStorage.setItem(
        "AddressRequestNumber",
        resp.data.data?.request_number
      );
      toast.success(resp.data.message?.message);
      setStep("AddressModificationProof");
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data.message?.message);
      setIsLoading(false);
    }
  };

  const handleDigilocker = async (value) => {
    if (value === "Yes") {
      setIsLoading(true);
      try {
        const resp = await createDgLockerApi();
        console.log("resp", resp);
        setIsLoading(false);
        window.location.href = resp?.data?.data?.url;
      } catch (error) {
        const { data } = error.response || {};
        toast.error(data.message?.message);
        setIsLoading(false);
      }
    } else {
      setIsLoading(true);
      try {
        const payload = { request_type: stageScreen };
        const resp = await previousAddressApi(payload);
        console.log("resp", resp);
        setIsLoading(false);
        if (resp.data?.data?.rekyc_modi_request_name) {
          setRequestData(resp.data.data);
          setStep("CreateRequest");
        } else {
          createModifyRequest();
        }
      } catch (error) {
        const { data } = error.response || {};
        toast.error(data.message?.message);
        setIsLoading(false);
      }
    }
  };
  return (
    <div>
      <Title title="Continue with DigiLocker" />
      <div className="col-md-12 mt-3">
        <h6>Do you want to proceed with digilocker?</h6>
        <div className="d-flex mt-4">
          <div className="">
            <Button
              type="button"
              title="Back"
              handleClick={() => setStep("ActiveUserInfo")}
              disabled={isLoading}
            />
          </div>
          <div className="mx-2">
            <Button
              title="Upload manually"
              handleClick={() => {
                setStep("CheckPrevRequest");
                setIsDigilocker(false);
              }}
              loading={isLoading}
            />
          </div>
          {DEMO_API_URL === getApiUrl() && (
            <div className="">
              <Button
                title="Yes"
                handleClick={() => {
                  setStep("CheckPrevRequest");
                  setIsDigilocker(true);
                }}
                loading={isLoading}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Digilocker;
